export default __webpack_public_path__ + "static/media/loading.42aaa181.gif";